<div class="section-switch-sheet">
  <!-- Drag Handle (M3 pattern) -->
  <div class="sheet-handle" aria-hidden="true"></div>

  <!-- Header -->
  <div class="sheet-header">
    <h2 class="sheet-title" i18n="@@home.sectionSwitch.title">セクションを切り替え</h2>
    <button mat-icon-button
            class="sheet-close"
            (click)="close()"
            i18n-aria-label="@@common.button.close"
            aria-label="閉じる">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Search Box -->
  <div class="search-box">
    <mat-icon class="search-icon">search</mat-icon>
    <input type="text"
           class="search-input"
           placeholder="セクションを検索..."
           [value]="searchQuery()"
           (input)="onSearchInput($event)"
           aria-label="セクションを検索"
           i18n-placeholder="@@home.sectionSwitch.searchPlaceholder" />
  </div>

  <!-- Section List -->
  <div class="section-list" role="listbox" aria-label="セクション一覧">
    @if (filteredSections().length === 0) {
      <div class="empty-message">
        <span i18n="@@home.sectionSwitch.noMatch">一致するセクションが見つかりません</span>
      </div>
    } @else {
      @for (section of filteredSections(); track section.id) {
        <button class="section-item"
                role="option"
                [class.section-item--current]="isCurrent(section)"
                [attr.aria-selected]="isCurrent(section)"
                (click)="selectSection(section)">
          <mat-icon class="section-item__icon" fontSet="material-icons-outlined">domain</mat-icon>
          <span class="section-item__name">{{ section.name }}</span>
          @if (isCurrent(section)) {
            <mat-icon class="section-item__check">check</mat-icon>
          }
        </button>
      }
    }
  </div>
</div>
